import React from "react";

const ModifierHelpOverlay = ({ items = [], onResume }) => {
    return (
        <div
            className="resumeOverlay resumeOverlay--help"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modifierHelpTitle"
        >
            <div className="resumeOverlay__panel modifierHelpOverlay__panel">
                <div id="modifierHelpTitle" className="resumeOverlay__title">
                    Run Help
                </div>
                {items.length ? (
                    <ul className="modifierHelpList">
                        {items.map((item) => (
                            <li key={item.id} className="modifierHelpList__item">
                                <div
                                    className={`modifierHelpList__title modifierHelpList__title--${item.id}`}
                                >
                                    {item.title}
                                </div>
                                <p className="modifierHelpList__description">
                                    {item.description}
                                </p>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="resumeOverlay__message">
                        No special modifiers on this run. Pick each card once —
                        repeating a card costs a heart.
                    </p>
                )}
                <button
                    type="button"
                    className="homePrimaryButton resumeOverlay__button"
                    onClick={onResume}
                >
                    Resume
                </button>
            </div>
        </div>
    );
};

export default ModifierHelpOverlay;
